import React from "react";
import Marquee from "react-fast-marquee";

const words = ["Chantilly Lace", "Farshi Suits", "Anarkali Dresses", "Co-ord Sets", "Hand Finished"];

export const EditorialMarquee = () => {
  return (
    <section className="py-10 md:py-14 bg-aak-secondary border-y border-aak-border overflow-hidden">
      <Marquee speed={30} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-serif italic font-light text-aak-fg text-5xl md:text-7xl px-8">
              {w}
            </span>
            <span className="text-aak-primary text-4xl md:text-6xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
